<template>
  <aside class="floating-sidebar-container" :class="{ 'is-open': isSidebarOpen }">
    <div class="sidebar-content-panel">
      <div class="sidebar-container-title">
        <h4>{{ toggleTitle }}</h4>
      </div>
      <div v-for="(service, index) in services" :key="index" class="sidebar-container">
        <a :href="service.Link" @click="handleLinkClick(service)">
          <div class="sidebar-image">
            <img :src="service.Icon" :alt="service.Title" />
          </div>
          <div class="sidebar-content">
            <h2>{{ service.Title }}</h2>
            <p>{{ service.Description }}</p>
          </div>
        </a>
      </div>
    </div>
    <button
      type="button"
      class="sidebar-toggle-button"
      :aria-expanded="isSidebarOpen.toString()"
      @click="toggleSidebar"
    >
      <span class="button-content">
        <img :src="floatingImage" :alt="floatingTitle" />
        <span>{{ floatingTitle }}</span>
      </span>
    </button>
  </aside>
</template>
<script>
export default {
  name: 'FloatingSidebar',
  props: {
    floatingTitle: {
      type: String,
      default: '',
    },
    floatingImage: {
      type: String,
      default: '',
    },
    toggleTitle: {
      type: String,
      default: '',
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isSidebarOpen: false,
    };
  },
  methods: {
    toggleSidebar() {
      const toggleTaggingObj = {
        ecommerce: 'undefined',
        event: 'uaevent',
        eventAction: this.isSidebarOpen ? 'close' : 'open',
        eventCategory: 'floating services',
        eventLabel: 'floating service button',
        event_name: 'floating_services',
        service_name: this.isSidebarOpen ? 'close' : 'open',
      };
      if (window.dataLayer) {
        window.dataLayer.push(toggleTaggingObj);
      }
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    handleLinkClick(service) {
      const serviceTaggingObj = {
        ecommerce: 'undefined',
        event: 'uaevent',
        eventAction: 'service select',
        eventCategory: 'floating services',
        eventLabel: service.Title,
        event_name: 'floating_service_select',
        service_name: service.Title,
      };
      if (window.dataLayer) {
        window.dataLayer.push(serviceTaggingObj);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$sidebar-width: 310px;
$toggle-button-width: 2.5rem;
$transition-speed: 0.7s;
.floating-sidebar-container {
  position: fixed;
  top: 30%;
  right: 0;
  height: auto;
  z-index: 9999999999;
}
.sidebar-content-panel {
  width: $sidebar-width;
  min-height: 215px;
  height: auto;
  background-color: #fff;
  box-shadow: 0 1rem 5rem rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  transition: transform $transition-speed ease-in-out;
  z-index: 9999999999;
  .sidebar-container-title {
    margin-left: 1rem;
    text-transform: uppercase;
    h4 {
      color: #000;
      font-size: 20px;
      font-weight: bolder;
      line-height: 32px;
      padding-top: 20px;
      padding-bottom: 25px;
      margin-bottom: 0;
    }
  }
  .sidebar-container {
    padding: 0px 20px 20px;
    &:last-child {
      padding-bottom: 10px;
    }
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: #000;
      cursor: pointer;
    }
    .sidebar-image {
      img {
        width: 55px;
        height: 55px;
        object-fit: cover;
        border-radius: 10px;
      }
    }
    .sidebar-content {
      width: 75%;
      padding-left: 20px;
      h2 {
        font-weight: bold;
        text-transform: uppercase;
        font-size: 16px;
        line-height: 19px;
        margin: 0;
      }
      p {
        font-size: 12px;
        line-height: 18px;
        margin-top: 10px;
      }
    }
  }
}
.sidebar-toggle-button {
  position: absolute;
  top: 0;
  right: 0;
  width: $toggle-button-width;
  height: 215px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform $transition-speed ease-in-out;
  z-index: 9999999999;
  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: nowrap;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 1px;
    img {
      width: 30px;
      padding: 1px;
      margin-bottom: 15px;
      transform: rotate(90deg);
    }
  }
}
.floating-sidebar-container {
  &.is-open {
    .sidebar-content-panel {
      transform: translateX(0);
    }
    .sidebar-toggle-button {
      transform: translateX(-$sidebar-width);
    }
  }
}
</style>
